export default (state) => {
  return {
    ...state,
    uiSettings: {
      ...state.uiSettings,
      new_agent_experience: {
        ...state.new_agent_experience,
        modal_seen: false,
      },
    },
  };
};
